export function* range(end: number = Number.POSITIVE_INFINITY, start = 0, step = 1): Generator<number, number, never> {
    let i = start - step

    while (true) {
        i += step
        if (i < end) yield i
        else return i
    }
}

export function indexes(obj?: null | undefined): Generator<number, never, never>
export function indexes<T extends unknown[]>(obj: T): Generator<number, undefined, never>
export function indexes<T>(obj: T): Generator<keyof T, undefined, never>
export function* indexes<T extends { [k: string]: never } | undefined | null>(
    obj?: T | null,
): Generator<number | keyof T, undefined | never, never> {
    if (!obj) {
        let i = 0
        while (true) yield i++
    } else if (Array.isArray(obj)) {
        let i = 0
        while (i < obj.length) yield i++
    } else {
        yield* Object.keys(obj) as (keyof T)[]
    }

    return undefined
}
